import { ForwardedRef, forwardRef, memo } from 'react';
import { Box, Input, Text, TextInput } from '@bonanza-social/moonlight';
import { DefaultFieldTypes } from './DefaultField.types';

function DefaultField(
  { value, onValue, ...rest }: DefaultFieldTypes,
  ref: ForwardedRef<TextInput>,
) {
  const valueType = typeof value;
  if (!valueType.match(/string|number/)) {
    return null;
  }

  const stringValue = String(value as string | number);

  return (
    <Box>
      {rest.headerKey ? (
        <Text
          color="darkSurfacePrimary"
          marginBottom="space-300"
          variant="h5"
          locNS="registration"
          locKey={rest.headerKey}
        />
      ) : null}
      <Input value={stringValue} ref={ref} onChangeText={onValue} {...rest} />
    </Box>
  );
}

export default memo(forwardRef(DefaultField));
